import React, { useEffect, useState } from 'react';
import '../styles/ScrollToTop.css';

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      className={`scroll-to-top ${visible ? 'show' : ''}`}
      onClick={scrollToTop}
      aria-label="Retour en haut"
    >
      {/* Icône SVG ou logo personnalisé */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path d="M8 3.293l6.364 6.364-1.414 1.414L8 6.121 3.05 11.07l-1.414-1.414L8 3.293z" />
      </svg>
    </button>
  );
};

export default ScrollToTop;

